import { REDUX_ACTIONS, GAME_ID } from 'a/allAboard/data/constants';

const initialState = {
  currentMaze: [[]],
  currentTrain: [{ x: 0, y: 0 }],
  endSquare: {},
  studentSelection: [],
  highlightedSquare: {},
  highlightedSquares: [],
  passengers: [],
  dualTrack: [],
  path: [],
  pendingPickupId: null,
  isShowIncorrectFeedback: false,
  isShowCorrectFeedback: false,
};

// Reducer that keep track of the maze, train, and path in a round (or onboarding).
// Data from this reducer is used for rendering graphics and for deciding which directions users can go

const mazeReducer = (state = initialState, { gameId, type, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.LOAD_MAZE:
      return {
        ...initialState,
        currentMaze: payload.currentMaze,
        currentTrain: payload.currentTrain,
        endSquare: payload.endSquare,
        passengers: payload.passengers,
        dualTrack: payload.dualTrack,
        path: payload.path,
      };

    case REDUX_ACTIONS.HIGHLIGHT_CELL:
      return {
        ...state,
        highlightedSquare: payload.cell,
        highlightedSquares: [...state.highlightedSquares, payload.cell],
      };
    case REDUX_ACTIONS.HIGHLIGHT_PATH:
      return {
        ...state,
        highlightedSquare: {},
        highlightedSquares: payload.cells,
      };
    case REDUX_ACTIONS.SELECT_CELL:
      return {
        ...state,
        studentSelection: [...state.studentSelection, payload],
      };

    case REDUX_ACTIONS.DESELECT_CELL:
      return {
        ...state,
        studentSelection: payload,
      };

    case REDUX_ACTIONS.CLEAR_SELECTION:
      return {
        ...state,
        studentSelection: [],
        isShowIncorrectFeedback: false,
      };
    case REDUX_ACTIONS.SET_SHOW_INCORRECT_FEEDBACK:
      return {
        ...state,
        isShowIncorrectFeedback: payload.isShowIncorrectFeedback,
      };
    case REDUX_ACTIONS.SET_SHOW_CORRECT_FEEDBACK:
      return {
        ...state,
        isShowCorrectFeedback: payload.isShowCorrectFeedback,
      };
    case REDUX_ACTIONS.CLEAR_HIGHLIGHT:
      return {
        ...state,
        highlightedSquare: {},
        highlightedSquares: [],
      };
    case REDUX_ACTIONS.GROW_TRAIN:
      return {
        ...state,
        currentTrain: payload.currentTrain,
        path: payload.path,
        pendingPickupId: payload.pendingPickupId,
      };

    case REDUX_ACTIONS.MOVE_TRAIN:
      return {
        ...state,
        currentTrain: payload.currentTrain,
        path: payload.path,
        pendingPickupId: payload.pendingPickupId,
      };

    case REDUX_ACTIONS.END_FEEDBACK:
      return {
        ...state,
        studentSelection: [],
        highlightedSquare: {},
        highlightedSquares: [],
        currentTrain: payload.currentTrain,
        passengers: payload.passengers,
        pendingPickupId: null,
      };

    default:
      return state;
  }
};

export default mazeReducer;
